import {img, icons, constructor} from '../utils/img';
import Message from './Message';
import OptionsList from './OptionsList';
import Options from './Options';
import ModalWindow from './ModalWindow';
import ShareButton from './ShareButton';
import PDFButton from './PDFButton';
import React from 'react';

import { apiConstructor } from '../api/ConstructorApi';

export default class SecondStage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            part: '',
            copyLink: '',
            renderConfig: {
                bg: constructor.bg, 
                stand: constructor.stand,
                standMaterial: '',
                sink: constructor.sink,
                tabletop: '',
                mirror: '',
                cabinet: '',
            },
            currentStandList: [],
            currentSinks: [],
            currentMirrorList: [],
            currentCabinetList: [],
        }
    }

    componentDidMount() {
        this.setImages();
        this._createShareLink();
    }

    componentDidUpdate(prevProps) {
        if(JSON.stringify(this.props.config) !== JSON.stringify(prevProps.config)) {
            this.setImages();
            this._createShareLink();
        }
    }

    _createShareLink() {
        const basedUrl = window.location.href.split('?')[0];
        const standPart = `?stand=${this.props.srcConfig.stand.article},${this.props.srcConfig.stand.id.replace(/ /g,'')},${this.props.srcConfig.stand.material},${this.props.srcConfig.stand.color},${this.props.srcConfig.stand.position || false},${this.props.srcConfig.stand.secondMaterial || false},${this.props.srcConfig.stand.secondColor || false}`;
        const sinkPart = `&sink=${this.props.srcConfig.sink === false ? 'false' : `${this.props.srcConfig.sink.article},${this.props.srcConfig.sink.position},${this.props.srcConfig.sink.flap}`}`;
        const tabletopPart = `&tabletop=${this.props.srcConfig.tabletop === false ? 'false' : `${this.props.srcConfig.tabletop.article},${this.props.srcConfig.tabletop.color},${this.props.srcConfig.tabletop.position}`}`;
        const mirrorPart = `&mirror=${this.props.srcConfig.mirror === false ? 'false' : `${this.props.srcConfig.mirror.article},${this.props.srcConfig.mirror.id},${this.props.srcConfig.mirror.material},${this.props.srcConfig.mirror.color}`}`;
        const cabinetPart = `&cabinet=${this.props.srcConfig.cabinet === false ? 'false' : `${this.props.srcConfig.cabinet.article},${this.props.srcConfig.cabinet.id},${this.props.srcConfig.cabinet.material},${this.props.srcConfig.cabinet.color},${this.props.srcConfig.cabinet.position},${this.props.srcConfig.cabinet.secondMaterial},${this.props.srcConfig.cabinet.secondColor}`}`
        const newUrl = basedUrl + standPart + sinkPart + tabletopPart + mirrorPart + cabinetPart;
        this.setState(state => {
            return {
                copyLink: newUrl
            }
        })
    }

    _filterSinks() {
        const filterSinksArray = []
        this.props.variableSinks.forEach(sink => {
            let check = true;
            filterSinksArray.forEach(sinkFilter => {
                if(JSON.stringify(sinkFilter) === JSON.stringify(sink) || sinkFilter.name === sink.name) {
                    check = false;
                }
                
            })
            if(check) {
                filterSinksArray.push(sink);
            }
        })
        return filterSinksArray
    }

    setImages() {
        this.props.updatePreloader(true);
        let postObject = {
            bg: this.props.config.stand !== false ? this.props.config.stand.stand.fileName : false,
            stand: this.props.config.stand !== false ? this.props.config.stand.stand.fileName : false,
            standType: this.props.config.stand !== false ? this.props.config.stand.positionStand === 'false' ? false : this.props.config.stand.positionStand : false,
            standMaterial: this.props.config.stand !== false ? this.props.config.stand.color : false,
            secondColor: this.props.config.stand !== false ? this.props.config.stand.secondColor === 'false' ? false : this.props.config.stand.secondColor : false,
            cutout: this.props.config.sink !== false ? !this.props.config.sink.cutout : true,
            sink: this.props.config.sink !== false ? this.props.config.sink.name.split(" for")[0].replace(/\s/g, "") : false,
            sinkPosition: this.props.config.sink !== false ? this.props.config.sink.position.replace('С', 'C') : false,
            sinkCountCup: this.props.config.sink !== false ? this.props.config.sink.sink.count_cup : false,
            sinkHeight:  this.props.config.sink !== false ? Number(this.props.config.sink.type.replace('mm', '')) : false,
            tabletop: this.props.config.tabletop !==false ? this.props.config.tabletop.color !== false ? this.props.config.tabletop.color: this.props.config.tabletop.type.replaceAll('_', '').replace('solidsurface', 'SolidSurface').replace('wide', '100').replace('thin', '12')   : false,
            tabletopPosition: this.props.config.tabletop !==false ? this.props.config.tabletop.position : false,
            mirror: this.props.config.mirror !== false ? this.props.config.mirror.name : false,
            mirrorMaterial: this.props.config.mirror !== false ? this.props.config.mirror.color : false,
            cabinet: this.props.config.cabinet !== false ? this.props.config.cabinet.cabinet.fileName : false,
            cabinetMaterial: this.props.config.cabinet !== false ? this.props.config.cabinet.color : false,
            cabinetSecondColor: this.props.config.cabinet!== false? this.props.config.cabinet.secondColor === 'false'? false : this.props.config.cabinet.secondColor : false,
        }
        let renderConf = {}
        const pRenders = new Promise((resolve, reject) => {
            apiConstructor.postRender(postObject)
            .then(res => {
                let rendersApi = res.data;
                this.props.updatePreloader(true)
                renderConf = {
                    bg: rendersApi.bg,
                    mirror: rendersApi.mirror,
                    mirrorMaterial: rendersApi.mirrorMaterial, 
                    standSecondColor: rendersApi.standSecondColor,
                    standMaterial: rendersApi.standMaterial,
                    sink: rendersApi.sink,
                    tabletop: rendersApi.tabletop,
                    cabinet: rendersApi.cabinet,
                    cabinetMaterial: rendersApi.cabinetMaterial,
                    cabinetsSecondColor: rendersApi.cabinetSecondColor
                }
                this.props.updateRenders(renderConf)
                resolve(true)
            })
            .catch(err => {
                this.props.updatePreloader(false)
                resolve(false)
            })
        })

        pRenders.then(res => {
            const offPReload = () => this.props.updatePreloader(false);
            const setImg = () => {
                this.setState(state => {
                    return {
                        renderConfig: renderConf
                    }
                })
            }
            const filterArray = Object.values(renderConf).filter(item => {return item!==undefined && item!=='' && item!==false});
            loadImage(0, offPReload, setImg);
            function loadImage(index, offPReload) {
                "use strict";
                var img = new Image();
                img.crossOrigin = 'anonymous'
                img.addEventListener("load", function () {
                    if(filterArray.length < index+1) {
                        loadImage(index+1, offPReload, setImg)
                    }
                    else {
                        offPReload();
                        setImg();
                    }
                });
                img.setAttribute("src", filterArray[index]);
            
            }
        })
    }

    updateStandList(list) {
        this.setState(state => {
            return {
                currentStandList: list
            }
        })
    }

    updateCurrentSink(sink) {
        this.setState(state => {
            return {
                currentSinks: sink,
            }
        })
    }

    updateMirrorList(list) {
        this.setState(state => {
            return {
                currentMirrorList: list
            }
        })
    }

    updateCabinetsList(list) {
        this.setState(state => {
            return {
                currentCabinetList: list
            }
        })
    }

    _cleanConfigTabletopAndSink() {
        let copyConfiguration = JSON.parse(JSON.stringify(this.props.srcConfig));
        copyConfiguration.sink = false;
        copyConfiguration.tabletop = false;
        this.props.setConfiguration(copyConfiguration);
    }

    _cleanConfigMirror() {
        let copyConfiguration = JSON.parse(JSON.stringify(this.props.srcConfig));
        copyConfiguration.mirror = false;
        this.props.setConfiguration(copyConfiguration);
    }

    _cleanConfigCabinet() {
        let copyConfiguration = JSON.parse(JSON.stringify(this.props.srcConfig));
        copyConfiguration.cabinet = false;
        this.props.setConfiguration(copyConfiguration);
    }

    render() {
        const config = [
            this.props.config.stand!== false && this.props.config.stand!== undefined ? {
                desk: 'Тумба',
                name: this.props.config.stand.stand.name,
                price: this.props.config.stand.price,
                color: this.props.config.stand.color,
            } : false,
            this.props.config.sink!== false && this.props.config.sink!== undefined ? {
                desk: 'Раковина',
                name: this.props.config.sink.sink.name,
                price: Number(this.props.config.sink.price) + (this.props.config.sink.position === 'D' ? 2 : 1) * Number(this.props.config.sink.flap.price || 0),
            } : false,
            this.props.config.tabletop!== false && this.props.config.tabletop!== undefined ? {
                desk: 'Столешница',
                name:  this.props.config.tabletop.type === 'kg_type_A' || this.props.config.tabletop.type === 'kg_type_B' ? 'Керамогранит' : 'Solid Surface',
                price: Number(this.props.config.tabletop.price) + Number(this.props.config.tabletop.countCup === 2 ? 3530 : 0)
            } : false,
        ];
        const standConfig = config[0]!== false ? config[0] : {desk: '', name: 'Не выбрана тумба', price: 0};
        const sinkOrTabletopConfig = config[1]!== false ? config[1] : config[2]!== false ? config[2] : {desk: '', name: 'Не выбрана раковина или столешница', price: 0}
        return (
            <section className='second-stage'>
                <div className='second-stage__picture'>
                    <div className={`${this.props.config.cabinet === false ? '' : 'second-stage__layout-button--scale'} second-stage__layout-button`}>
                        <div className='second-stage__button second-stage__button--mirror'>
                            
                            <button 
                                className={`second-stage__button--pin button button--pin ${this.props.part === 'mirror' ? 'second-stage__button--active' : ''}`}
                                onClick = {() => this.props.updatePart('mirror')}

                            ></button>
                            <div className='second-stage__promt'>
                                <span className='second-stage__desc'>Зеркало</span>
                                <span className='second-stage__name'>{this.props.config.mirror=== false ? 'Не выбрано' : `${this.props.config.mirror.name}`}</span>
                                <span className='second-stage__price'>{this.props.config.mirror=== false ? '' : `${this.props.config.mirror.price} Р`}</span>
                            </div>
                            {
                                this.props.config.mirror !== false ?
                                <button className='second-stage__remove-cross' onClick={() => this._cleanConfigMirror()}>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.8" d="M1 1L5 5M5 5L9 9M5 5L9 1M5 5L1 9" stroke="#EDEDED" strokeLinecap="round"/>
                                    </svg>
                                </button>
                                :
                                <></>
                            }
                            
                            
                        </div>

                        <div className='second-stage__button second-stage__button--cabinet'>
                            
                            <button 
                                className={`second-stage__button--pin button button--pin ${this.props.part === 'cabinet' ? 'second-stage__button--active' : ''} 
                                ${this.props.variableCabinets.length === 0 ? 'second-stage__button--disabled' : ''}`}
                                onClick = {() => this.props.updatePart('cabinet')}
                            ></button>
                            <div className='second-stage__promt'>
                                <span className='second-stage__desc'>Пенал</span>
                                <span className='second-stage__name'>{this.props.config.cabinet=== false ? 'Не выбрано' : `${this.props.config.cabinet.name}`}</span>
                                <span className='second-stage__price'>{this.props.config.cabinet=== false ? '' : `${this.props.config.cabinet.price} Р`}</span>
                            </div>
                            {
                                this.props.config.cabinet !== false ?
                                <button className='second-stage__remove-cross' onClick={() => this._cleanConfigCabinet()}>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.8" d="M1 1L5 5M5 5L9 9M5 5L9 1M5 5L1 9" stroke="#EDEDED" strokeLinecap="round"/>
                                    </svg>
                                </button>
                                :
                                <></>
                            }
                            
                        </div>

                        <div className='second-stage__button second-stage__button--sink'>
                            
                            <button 
                                className={`second-stage__button--pin button button--pin ${this.props.part === 'sink' || this.props.part === 'tabletop' || this.props.part === 'sink-choice' || this.props.part === 'tabletop' ? 'second-stage__button--active' : ''}`} 
                                onClick = {() => this.props.updatePart('sink')}></button>
                            <div className='second-stage__promt'>
                                <span className='second-stage__desc'>{sinkOrTabletopConfig.desk}</span>
                                <span className='second-stage__name'>{sinkOrTabletopConfig.name}</span>
                                <span className='second-stage__price'>{sinkOrTabletopConfig.price + ' Р'}</span>
                            </div>
                            {
                                
                                this.props.config.sink !== false || this.props.config.tabletop !== false ?
                                <button className='second-stage__remove-cross' onClick={() => this._cleanConfigTabletopAndSink()}>
                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.8" d="M1 1L5 5M5 5L9 9M5 5L9 1M5 5L1 9" stroke="#EDEDED" strokeLinecap="round"/>
                                    </svg>
                                </button>
                                :
                                <></>
                            }
                            
                            
                        </div>
                        <div className='second-stage__button second-stage__button--stand'>
                        <button 
                            className={`second-stage__button--pin button button--pin ${this.props.part === 'stand' ? 'second-stage__button--active' : ''}`}
                            onClick = {() => this.props.updatePart('stand')}></button>
                            <div className='second-stage__promt'>
                                <span className='second-stage__desc'>{standConfig.desk}</span>
                                <span className='second-stage__name'>{standConfig.name}</span>
                                <span className='second-stage__price'>{standConfig.price + ' Р'}</span>
                            </div>
                        </div>
                    </div>
                    <div className='second-stage__background'>
                        {Object.values(this.state.renderConfig).map((img, i) => {
                            if(img!=='' && img!==undefined && img!==false) {
                                return <img className={`${this.props.config.cabinet === false ? 'second-stage__background-img-scale' : ''}`} key={i} src= {img} />
                            }
                        })}
                    </div>
                    <div className='second-stage__controls'>
                        <ShareButton copyLink={this.state.copyLink}/>
                            <PDFButton openModal={this.props.openModal} canvasRef={this.props.canvasRef} imgSrc = {this.props.imgSrc} config = {this.props.config} setImageSrc={this.props.setImageSrc} imgs={this.state.renderConfig} info={this.props.config}>
                        </PDFButton>

                        
                    </div>
                    
                </div>
                <div className='second-stage__option-list-wrap'>
                    
                    {this.props.part === '' ? <Message/> : ''}
                    {this.props.part !== '' ?
                        <OptionsList 
                            //main config
                            config = {this.props.config}
                            srcConfig = {this.props.srcConfig}
                            setConfiguration = {this.props.setConfiguration}
                            variableOptions = {this.props.variableOptions}

                            
                            //utils
                            updatePart = {this.props.updatePart}
                            part = {this.props.part}
                            setStatusWindow = {this.props.setStatusWindow}
                            initModal = {this.props.initModal}
                            miniImg = {this.props.miniImg}
                            setVariableOptions = {this.props.setVariableOptions}

                            //variables parts
                            allVariableSinks = {this.props.variableSinks}
                            variableSinks = {this._filterSinks()}
                            variableTabletops = {this.props.variableTabletops}
                            variableCabinets = {this.props.variableCabinets}
                            
                            //preloader
                            updatePreloader = {this.props.updatePreloader}

                            //choice stand list
                            updateStandList = {this.updateStandList.bind(this)}
                            //choice sink list
                            updateCurrentSink = {this.updateCurrentSink.bind(this)}
                            //choice mirror list
                            updateMirrorList = {this.updateMirrorList.bind(this)}
                            //choice cabinet list
                            updateCabinetsList = {this.updateCabinetsList.bind(this)}
                        /> 
                        : ''
                    }
                    <div className='options-menu'>
                        <Options renderConfig = {this.state.renderConfig} setStatusWindow = {this.props.setStatusWindow} config={this.props.config}/>
                    </div>
                    
                </div>


                
                <ModalWindow
                    config = {this.props.config}
                    srcConfig = {this.props.srcConfig}
                    setConfiguration = {this.props.setConfiguration}
                    allVariableSinks = {this.props.variableSinks}
                    variableOptions = {this.props.variableOptions}


                    //utils 
                    type={this.props.typeModalWindow} 
                    updatePart={this.props.updatePart}
                    setStatusWindow={this.props.setStatusWindow} 
                    status={this.props.statusModalWindow} 
                    part={this.props.part}
                    
                    sliderImgs = {this.props.sliderImgs}
                    description = {this.props.description}
                    setStatusCheckout = {this.props.setStatusCheckout}
                    changeCurrentStage = {this.props.changeCurrentStage}
                    

                    //notice
                    updateNoticeStatus = {this.props.updateNoticeStatus}
                    updatePreloader = {this.props.updatePreloader}

                    //config
                    currentStandList = {this.state.currentStandList}
                    currentSinks = {this.state.currentSinks}
                    currentTabletops = {this.props.variableTabletops}
                    currentMirrorList = {this.state.currentMirrorList}
                    currentCabinetList = {this.state.currentCabinetList}

                    generatePdf = {() => this.props.generatePdf()}
                />
            </section> 
        )
    }
}